import { z } from 'zod';
import type React from 'react';

// Apoio stateless (régua de 400 linhas) — extraído sem mudança de comportamento.
export const STATUS_LABELS: Record<string, string> = {
  ACTIVE: 'Ativo',
  AWAY: 'Ausente',
  SUSPENDED: 'Suspenso',
  DRAFT: 'Rascunho',
  DISCONNECTED: 'Desligado',
  DECEASED: 'Falecido',
  ARCHIVED: 'Arquivado',
};

export const STATUS_VARIANTS: Record<string, string> = {
  ACTIVE: 'success',
  AWAY: 'warning',
  SUSPENDED: 'danger',
  DRAFT: 'info',
  DISCONNECTED: 'default',
  DECEASED: 'default',
  ARCHIVED: 'default',
};

export const MEMBERSHIP_LABELS: Record<string, string> = {
  MEMBER: 'Membro(a)',
  COLLABORATOR: 'Colaborador(a)',
  COORDINATION: 'Coordenação',
  DIRECTOR: 'Direção',
  VISITOR: 'Visitante',
  SUPPORT: 'Apoio',
  OTHER: 'Outro',
};

export const personFormSchema = z.object({
  civilName: z.string().min(1, 'Nome civil é obrigatório'),
  socialName: z.string().optional().or(z.literal('')),
  religiousName: z.string().optional().or(z.literal('')),
  oriki: z.string().optional().or(z.literal('')),
  email: z.string().email('E-mail inválido').optional().or(z.literal('')),
  phone: z.string().optional().or(z.literal('')),
  birthDate: z.string().optional().or(z.literal('')),
});

export type PersonForm = z.infer<typeof personFormSchema>;

export type Tab = 'dados' | 'vinculo' | 'historico' | 'cargos';

export function fmtDate(v: unknown): string {
  if (typeof v === 'string' && v.length >= 10) return v.substring(0, 10);
  if (v instanceof Date) return v.toISOString().substring(0, 10);
  return '—';
}

export function Field({
  label,
  error,
  children,
}: {
  label: string;
  error?: string;
  children: React.ReactNode;
}) {
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', fontSize: '0.8rem' }}>
      <span style={{ color: 'var(--ink)', fontWeight: 600 }}>{label}</span>
      {children}
      {error && <span style={{ color: 'var(--danger)', fontSize: '0.7rem' }}>{error}</span>}
    </label>
  );
}

export function SkeletonDetail() {
  return (
    <div style={{ padding: '2.25rem 2.5rem', maxWidth: 900 }}>
      <div
        style={{
          width: 160,
          height: 14,
          background: 'var(--line-soft)',
          borderRadius: 8,
          marginBottom: '1.5rem',
        }}
      />
      <div
        style={{
          width: '60%',
          height: 24,
          background: 'var(--line-soft)',
          borderRadius: 8,
          marginBottom: '2rem',
        }}
      />
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          style={{
            background: '#fff',
            borderRadius: 14,
            border: '1px solid var(--line)',
            padding: '1.25rem 1.5rem',
            height: 100,
            marginBottom: '1rem',
          }}
        >
          <div
            style={{
              width: '30%',
              height: 14,
              background: 'var(--line-soft)',
              borderRadius: 8,
              marginBottom: '0.75rem',
            }}
          />
          <div
            style={{
              width: '60%',
              height: 12,
              background: 'var(--soft)',
              borderRadius: 8,
              marginBottom: '0.5rem',
            }}
          />
          <div style={{ width: '40%', height: 12, background: 'var(--soft)', borderRadius: 8 }} />
        </div>
      ))}
    </div>
  );
}

export const dlGrid: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '180px 1fr',
  gap: '0.5rem 1rem',
  fontSize: '0.875rem',
};

export const Dt = ({ children }: { children: React.ReactNode }) => (
  <dt style={{ color: 'var(--ink)', fontWeight: 600, margin: 0 }}>{children}</dt>
);

export const Dd = (props: React.HTMLAttributes<HTMLElement> & { children: React.ReactNode }) => (
  <dd style={{ margin: 0, color: 'var(--ink)', ...props.style }}>{props.children}</dd>
);

export const inputCss: React.CSSProperties = {
  width: '100%',
  padding: '0.5rem 0.6rem',
  border: '1px solid var(--line)',
  borderRadius: 10,
  fontSize: '0.85rem',
  boxSizing: 'border-box',
  outline: 'none',
};

export const primaryBtn: React.CSSProperties = {
  background: 'var(--green)',
  color: '#fff',
  border: 'none',
  borderRadius: 999,
  padding: '0.45rem 1rem',
  fontSize: '0.8rem',
  fontWeight: 600,
  cursor: 'pointer',
};

export const secondaryBtn: React.CSSProperties = {
  background: '#fff',
  color: 'var(--muted)',
  border: '1px solid var(--line)',
  borderRadius: 999,
  padding: '0.45rem 1rem',
  fontSize: '0.8rem',
  cursor: 'pointer',
};

export const linkBtn: React.CSSProperties = {
  background: 'none',
  border: 'none',
  color: 'var(--muted)',
  cursor: 'pointer',
  fontSize: '0.875rem',
  marginBottom: '0.5rem',
  display: 'block',
  padding: 0,
};
